// Validasi INPUT form saja, diturunkan dari openapi.yaml (ConditionInput, TherapyInput).
// Kelengkapan versi (findings) TIDAK dihitung di sini — itu dari
// GET /version-rule/{id}/validation.
import { OPERATORS, fieldByValue, isMultiOperator } from "./constants";

const isBlank = (v) => v === "" || v === null || v === undefined;

// ConditionInput.value bergantung pada operator: EQUALS → scalar; IN → array;
// LT/LTE/GT/GTE → number; BETWEEN → [min, max]; *_OF/MIX_* → array spesies.
export const getConditionErrors = (condition) => {
  const errors = {};
  const field = fieldByValue(condition.field_code);
  const { operator, value } = condition;
  if (!field) errors.field_code = "Pilih field kondisi";
  if (!operator) errors.operator = "Pilih operator";
  else if (field && !OPERATORS[field.type].includes(operator))
    errors.operator = `Operator ${operator} tidak berlaku untuk ${field.label}`;

  if (operator === "BETWEEN") {
    const [min, max] = value || [];
    if (isBlank(min) || isBlank(max)) errors.value = "Isi batas bawah dan atas";
    else if (Number(min) > Number(max)) errors.value = "Batas bawah melebihi batas atas";
  } else if (isMultiOperator(operator)) {
    if (!Array.isArray(value) || !value.length) errors.value = "Pilih minimal satu nilai";
  } else if (isBlank(value)) errors.value = "Nilai wajib diisi";
  return errors;
};

// TherapyInput: drug_id wajib; regimen_id wajib untuk DOSE_BAND dan null untuk
// PRESENT; satu Drug paling banyak sekali per Rule (HANDOFF §6.2).
export const getTherapyErrors = (therapy, siblings = []) => {
  const errors = {};
  if (!therapy.drug_id) errors.drug_id = "Pilih obat";
  else if (siblings.some((t) => t !== therapy && t.drug_id === therapy.drug_id))
    errors.drug_id = "Obat ini sudah dipakai terapi lain pada rule yang sama";
  if (!therapy.operator) errors.operator = "Pilih operator";
  if (therapy.operator === "DOSE_BAND" && !therapy.regimen_id) errors.regimen_id = "DOSE_BAND wajib memilih aturan dosis";
  if (therapy.operator === "PRESENT" && therapy.regimen_id) errors.regimen_id = "PRESENT tidak memakai aturan dosis";
  if ((therapy.exclusive_group || "").length > 20) errors.exclusive_group = "Maksimal 20 karakter";
  return errors;
};

export const hasTherapyInputErrors = (therapies) =>
  therapies.some((t) => Object.keys(getTherapyErrors(t, therapies)).length > 0);

// Body PUT …/conditions & …/therapies (ConditionInput[] / TherapyInput[]).
export const toConditionInputs = (conditions) =>
  conditions.map(({ field_code, operator, value }) => ({ field_code, operator, value }));
export const toTherapyInputs = (therapies) =>
  therapies.map(({ drug_id, regimen_id, operator, exclusive_group }) => ({
    drug_id,
    regimen_id: operator === "PRESENT" ? null : regimen_id,
    operator,
    exclusive_group: exclusive_group ? exclusive_group : null,
  }));
